module.exports = __webpack_public_path__ + "static/media/i-10.3a2ce084.svg";